import { z } from 'zod';
import { KeyResultType, IssueVisibility } from '@momentum/types';

export const createGoalSchema = z.object({
  title: z
    .string()
    .min(1, 'Title is required')
    .max(200, 'Title must be less than 200 characters'),
  description: z
    .string()
    .max(2000, 'Description must be less than 2000 characters')
    .optional(),
  assignees: z.array(z.string()).optional(),
  creator: z.string().min(1, 'Creator is required'),
  link: z.string().optional(),
  collaborators: z.array(z.string()).optional(),
  startDate: z.string().optional(),
  dueDate: z.string().optional(),
  status: z.string(),
  parent: z.string().optional(),
  keyResults: z
    .array(
      z.object({
        _id: z.string().optional(),
        title: z.string().min(1, 'Title is required'),
        unit: z.string().min(1, 'Unit is required'),
        quantity: z.number().min(0, 'Quantity is required'),
        currentProgress: z
          .number()
          .min(0, 'Current progress must be greater than or equal to 0'),
        type: z.enum(KeyResultType),
      })
    )
    .optional(),
  viewers: z
    .object({
      users: z.array(z.string()),
      teams: z.array(z.string()),
    })
    .optional(),
  visibility: z.nativeEnum(IssueVisibility),
});

export type CreateGoalFormData = z.infer<typeof createGoalSchema>;

export const defaultValues: CreateGoalFormData = {
  title: '',
  description: '',
  assignees: [],
  creator: '',
  status: 'TODO',
  keyResults: [],
  viewers: { users: [], teams: [] },
  visibility: IssueVisibility.PUBLIC,
};
